import axios from '@/axios';

const endpoint = '/business';

const BusinessClaim = {
  async claim(payload) {
    const res = await axios.post(`${endpoint}/claim`, {
      name: payload.name,
      street: payload.street,
      street2: payload.address2,
      city: payload.city,
      state: payload.state,
      zip: payload.zip,
      phone: payload.phone,
      email: payload.email,
      description: payload.description
    });

    return {
      found: res.found ?? false,
      claimed: res.claimed ?? false,
      businessId: res.businessId ?? null,
      message: res.message ?? ''
    };
  },

  async confirm({ businessId }) {
    return axios.post(`${endpoint}/confirm-claim`, { businessId });
  },

  async cancel({ businessId }) {
    return axios.post(`${endpoint}/cancel-claim`, { businessId });
  },

  async details(businessId) {
    return axios.get(`${endpoint}/${businessId}/details`);
  }
};

export default BusinessClaim;
